import './axios'
import './moment'
import './lodash'
import './jquery'



// WEBPACK FOOTER //
// ./resources/js/plugins/index.js